import { render, staticRenderFns } from "./select_incidenttype.vue?vue&type=template&id=6a83cdb4&scoped=true"
import script from "./select_incidenttype.vue?vue&type=script&lang=js"
export * from "./select_incidenttype.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a83cdb4",
  null
  
)

export default component.exports